import './style.css';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import cx from 'classnames';
import { omit } from 'lodash';

class ProfilePicture extends Component {
  static get propTypes() {
    return {
      isPictureRemovable: PropTypes.bool,
      removeIconDisabled: PropTypes.bool,
      onPictureRemove: PropTypes.func,
      // container
      prefixCls: PropTypes.string,
      className: PropTypes.string,
      style: PropTypes.object,
      // picture
      loadedPicture: PropTypes.node.isRequired,
      pictureAlt: PropTypes.string,
    };
  }
  static get defaultProps() {
    return {
      isPictureRemovable: false,
      removeIconDisabled: false,
      onPictureRemove: () => {},
      prefixCls: 'profile-picture',
    };
  }

  constructor() {
    super();
    this.containerInst = null;
    this.pictureInst = null;
    this.updateStyle = this.updateStyle.bind(this);
  }

  componentDidMount() {
    const { props } = this;
    this.updateStyle(props);
  }

  componentDidUpdate() {
    const { props } = this;
    this.updateStyle(props);
  }

  updateStyle(props) {
    const picture = findDOMNode(this.pictureInst);
    if (!picture) return false;

    // change width or height ratio
    const tempImage = new Image();
    tempImage.src = props.loadedPicture;
    const handleTempImageLoaded = (_props) => {
      const {
        width: originalWidth,
        height: originalHeight,
      } = tempImage;
      picture.className = cx(`${_props.prefixCls}__image`, {
        [`${_props.prefixCls}__image--more-width`]: originalWidth >= originalHeight,
        [`${_props.prefixCls}__image--more-height`]: originalHeight > originalWidth,
      });
      picture.src = _props.loadedPicture;
    };

    tempImage.onload = handleTempImageLoaded.bind(this, props);
  }

  render() {
    const { props } = this;
    const {
      className,
      prefixCls,
      style,
      pictureAlt,
      isPictureRemovable,
      removeIconDisabled,
      onPictureRemove,
    } = props;
    const divProps = Object.assign({}, props);

    return (
      <div {...omit(divProps, ['isPictureRemovable', 'removeIconDisabled', 'onPictureRemove', 'loadedPicture', 'prefixCls'])}
        className={cx(prefixCls, className)}
        ref={inst => (this.containerInst = inst)}
        style={style}
      >
        <img className={`${prefixCls}__image`}
          ref={inst => (this.pictureInst = inst)}
          alt={pictureAlt}
        />
        {
          isPictureRemovable
          && (
            <button
              type="button"
              disabled={removeIconDisabled}
              className={cx(`${prefixCls}__remove`, {
                [`${prefixCls}__remove--disabled`]: removeIconDisabled,
              })}
              onClick={onPictureRemove}
            >
              <i className={`fa fa-times-circle ${prefixCls}__remove-icon`} aria-hidden="true" />
            </button>
          )
        }
      </div>
    );
  }
}

export default ProfilePicture;



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/components/ProfilePicture/index.js
 **/